import script from "./Tiptap.vue?vue&type=script&setup=true&lang=js"
export * from "./Tiptap.vue?vue&type=script&setup=true&lang=js"

import "./Tiptap.vue?vue&type=style&index=0&id=5cebb123&lang=scss"

const __exports__ = script;

export default __exports__